export default {
  apiHost: 'http://47.101.39.148',
  mapKey: '2275f97cfc594371acad0f97d53090d9'
}
